import { useDispatch, useSelector } from 'react-redux';

import {
  handleOpenSetting,
  handleSelector,
  handleToggleSSR,
  selectEssSwitch,
} from '../store/slices/essSwitchSlice';

import {
  selectTesSwitch,
  tesHandleOpenSetting,
  tesHandleSelector,
  tesHandleToggleSSR,
} from '../store/slices/tesSwitchSlice';

import { useMediaQuery } from 'react-responsive';
import styled, { css } from 'styled-components';

import SSRInfoContainer from './SSRInfoContainer';
// import SwitchNameSelector from './SwitchNameSelector';
import SSRToggleSWitch from './SSRToggleSwitch';
import SSRSelect from './SSRSelect';
import {
  alignItemsFlexStart,
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentFlexEnd,
  justifyContentSpaceBetween,
  layerA,
} from '../styles/commonStyles';
import SSRInfoCommonContainer from './SSRInfoCommonCopntainer';
import { useState } from 'react';
import { useEffect } from 'react';
import { selectUnits } from '../store/slices/settings/unitsSlice';
import { selectUserInfo, selectUserPermissions } from '../store/slices/userSlice';
import AdminSSRItemDetails from './AdminSSRItemDetails';
import ContainerLogin from '../adminPassword/ContainerLogin';
import {
  updateBlowerSettingService,
  updateSwitchSettingService,
} from '../../services';
import SwitchNameSelector from './SwitchNameSelector';

const SSRDetail = ({
  swtName,
  data,
  id,
  location,
  machine,
  indivLocationName,
  isUpdating,
  setIsUpdating,
  localActivatedHeaters,
  setLocalActivatedHeaters
}) => {
  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;
  const permissions = useSelector(selectUserPermissions);
  const disable = !permissions.WRITE;
  
  const { essSwitch, tesSwitch,flatEssSwitch,flatTesSwitch } = useSelector(
    swtName === 'ess' ? selectEssSwitch : selectTesSwitch
  );
  const switchData = swtName === 'ess' ? flatEssSwitch : flatTesSwitch;
  const switchStatus = switchData[location][machine];

  const { deviceMac, heaterThermocoupleMap, activeThermocouples } = switchStatus;

  // An SSR is filled to a current budget rather than a heater count, so it can
  // carry several heaters — four 5a elements on a 20a SSR. The mobile panel used
  // to read specs[0] and show only the first of them.
  const heaters = (data?.specs || []).map((spec) => ({
    current: spec?.current ?? 0,
    currentCurrent: spec?.currentCurrent ?? 0,
    elementName: spec?.elementName ?? '',
    partNumber: spec?.partNumber ?? '',
    voltage: spec?.voltage ?? 0,
    wattage: spec?.wattage ?? 0,
    lengths: spec?.lengths ?? 0,
  }));
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });
  const { isSettingOpen, buttonStatus } = data;
  const dispatch = useDispatch();
  const { isAdministrator } = useSelector(selectUserInfo);
  const [openPasswordBox, setOpenPasswordBox] = useState(false);

  const setSettingOpen = (status) =>
    dispatch(
      (swtName === 'ess' ? handleOpenSetting : tesHandleOpenSetting)({
        location,
        machine,
        id: `ssr${id}`,
        status,
      })
    );

  // Editing heaters is an administrator action. Non-admins get the same
  // password box the desktop panel puts behind its settings cog.
  const handleMobileSettingButton = () => {
    if (isSettingOpen) {
      setSettingOpen(false);
    } else if (isAdministrator) {
      setSettingOpen(true);
    } else {
      setOpenPasswordBox(true);
    }
  };

  const [isOverAmp, setIsOverAmp] = useState(false);
  const [SSRSwitchName, setSSRSwitchName] = useState('');

  const disabled = buttonStatus === 'flt' || buttonStatus === 'off';

  // check current amp
  useEffect(() => {
    const maxTemp = data?.specs[0]?.current * 0.2 + data?.specs[0]?.current;
    const minTemp = -data?.specs[0]?.current * 0.2 + data?.specs[0]?.current;

    const check =
      data?.specs[0]?.currentCurrent > maxTemp ||
      data?.specs[0]?.currentCurrent < minTemp;

    check ? setIsOverAmp(true) : setIsOverAmp(false);
  }, [data?.specs[0]]);

useEffect(() => {

}, [localActivatedHeaters]);
  const integratedButtonHandler = (data) => {
    switch (data.button) {
      case 'SSRSelect':
        const newHeaterThermocoupleMap = {
          heater_thermocouple_map: heaterThermocoupleMap.map(
            (select, index) => {
              if (index === id - 1) {
                return Number(data.data.slice(-2));
              } else {
                return select;
              }
            }
          ),
        };
        swtName === 'ess'
          ? updateSwitchSettingService(
              [deviceMac],
              newHeaterThermocoupleMap
            ).then(() => {
              dispatch(
                handleSelector({
                  location,
                  machine,
                  id: data.id,
                  data: data.data,
                })
              );
            })
          : updateBlowerSettingService(
              [deviceMac],
              newHeaterThermocoupleMap
            ).then(() => {
              dispatch(
                tesHandleSelector({
                  location,
                  machine,
                  id: data.id,
                  data: data.data,
                })
              );
            });
        break;
      case 'toggle':
        if (isUpdating) return; 
  setIsUpdating(true); 
        const newActivatedHeaters = {
          activated_heaters: localActivatedHeaters.map((value, index) => {
            if (index === id - 1) {
              return Number(data.buttonStatus === 'on' ? 1 : 0);
            } else {
              return value;
            }
          }),
        };
     const serverResponse =
  swtName === 'ess'
    ? updateSwitchSettingService([deviceMac], newActivatedHeaters).then(
        (serverData) => {
        

        
        const isDifferent = serverData[0]?.activated_heaters?.some(
  (val, idx) => val !== newActivatedHeaters.activated_heaters[idx]
) ?? true;
              
              
          if (!isDifferent) {
            dispatch(
              handleToggleSSR({
                location,
                machine,
                id: data.id,
                buttonStatus: data.buttonStatus,
              })
            );
            setLocalActivatedHeaters(serverData[0]?.activated_heaters);
            
            setIsUpdating(false);
          }
        }
      )
    : updateBlowerSettingService([deviceMac], newActivatedHeaters).then(
        (serverData) => {
          

        const isDifferent = serverData[0]?.activated_heaters?.some(
  (val, idx) => val !== newActivatedHeaters.activated_heaters[idx]
) ?? true;


          if (!isDifferent ) {
            dispatch(
              tesHandleToggleSSR({
                location,
                machine,
                id: data.id,
                buttonStatus: data.buttonStatus,
              })
            );
            setIsUpdating(false);
          }
        }
      );


        break;
      default:
        break;
    }
  };

  return (
    <>
      {isMobile ? (
        <Wrapper
          isMobile={isMobile}
          isOverAmp={isOverAmp}
          isOff={buttonStatus === 'off'}
          isFault={buttonStatus === 'flt'}
        >
          <MobileHeaderRow>
            <ToggleSWitchContainer isMobile={true}>
              <SSRToggleSWitch
                isMobile={true}
                data={data}
                id={id}
                buttonHandler={integratedButtonHandler}
                disable={disable}
                switch_panels={switchStatus?.switch_panels}
                isUpdating={isUpdating}
                setIsUpdating={setIsUpdating}
              />
            </ToggleSWitchContainer>

            <SSRSelect
              isMobile={true}
              data={data.select}
              status={data.buttonStatus}
              id={id}
              buttonHandler={integratedButtonHandler}
              activeThermocouples={activeThermocouples}
            />
            <MobileSettingButton
              type='button'
              disabled={disable}
              aria-label={
                isSettingOpen
                  ? `close ssr ${id} heater settings`
                  : `open ssr ${id} heater settings`
              }
              onClick={() => !disable && handleMobileSettingButton()}
            >
              <MobileSettingIcon src='/images/admin-setting.svg' />
            </MobileSettingButton>
          </MobileHeaderRow>

          {isSettingOpen ? (
            <AdminSSRItemDetails
              isMobile={true}
              id={id}
              data={data}
              isEnable={buttonStatus === 'on'}
              isFault={buttonStatus === 'flt'}
              isWarn={data.warn === 1}
              // Closes the panel once a change has been applied, matching what
              // the settings cog does on desktop.
              handleButtonClick={() => setSettingOpen(false)}
              location={location}
              machine={machine}
              swtName={swtName}
            />
          ) : (
            heaters.map((heater, index) => (
              <HeaterBlock key={index}>
                {heaters.length > 1 && (
                  <HeaterBlockTitle>
                    heater {index + 1} of {heaters.length}
                  </HeaterBlockTitle>
                )}

                <HeaterFigures>
                  <SSRInfoCommonContainer
                    data={{ t: heater.current, a: heater.currentCurrent }}
                    title='current'
                    unit='a'
                    disabled={disable}
                  />
                  <SSRInfoCommonContainer
                    data={heater.wattage}
                    title='wattage'
                    unit='w'
                    disabled={disabled}
                  />
                  <SSRInfoCommonContainer
                    data={heater.voltage}
                    title='voltage'
                    unit='v'
                    disabled={disabled}
                  />
                  <SSRInfoCommonContainer
                    data={heater.lengths}
                    title='length'
                    unit={'ft'}
                    disabled={disabled}
                  />
                </HeaterFigures>

                <SectionContainer isLast={true}>
                  <SSRInfoCommonContainer
                    disabled={disabled}
                    data={{
                      a: `${heater.elementName} - ${heater.partNumber}`,
                      b: `${heater.current} a / ${heater.wattage} w / ${heater.voltage} v / ${heater.lengths} ft`,
                    }}
                    title='description'
                    unit={null}
                  />
                </SectionContainer>
              </HeaterBlock>
            ))
          )}

          {openPasswordBox && (
            <MobilePasswordWrapper onClick={() => setOpenPasswordBox(false)}>
              <ContainerLogin
                setIsSettingOpen={() => setSettingOpen(true)}
                handleClose={() => setOpenPasswordBox(false)}
                isReadyToClose={true}
              />
            </MobilePasswordWrapper>
          )}
        </Wrapper>
      ) : (
        <Wrapper>
          <FlexContainer>
            <SSRSelect
              isMobile={false}
              data={data.select}
              status={data.buttonStatus}
              id={id}
              buttonHandler={integratedButtonHandler}
              activeThermocouples={activeThermocouples}
            />

            <ToggleSWitchContainer>
              <SSRToggleSWitch
                isMobile={false}
                data={data}
                id={id}
                buttonHandler={integratedButtonHandler}
                disable={disable}
                switch_panels={switchStatus?.switch_panels}
                isUpdating={isUpdating}
                setIsUpdating={setIsUpdating}
              />
            </ToggleSWitchContainer>

            <SSRInfoContainer
              swtName={swtName}
              data={data}
              id={id}
              location={location}
              machine={machine}
              isSettingOpen={isSettingOpen}
              isOverAmp={isOverAmp}
              SSRSwitchName={SSRSwitchName}
              setSSRSwitchName={setSSRSwitchName}
            />
          </FlexContainer>
          <SwitchNameSelectorWrapper>
            {isSettingOpen && (
              <>
                <SwitchNameSelector
                  data={data}
                  SSRSwitchName={SSRSwitchName}
                  setSSRSwitchName={setSSRSwitchName}
                  ssrId={id - 1}
                  swtName={swtName}
                  location={location}
                  machine={machine}
                />
              </>
            )}
          </SwitchNameSelectorWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default SSRDetail;
const SectionContainer = styled.section`
  width: 100%;
  ${justifyContentSpaceBetween}

  ${(p) =>
    p.isFirst &&
    css`
      ${justifyContentFlexEnd};
    `};

  ${(p) =>
    p.isLast &&
    css`
      ${flexBoxCenter};
    `}
`;

// On/off toggle, thermocouple selector, heater-settings cog — one row, aligned
// to the top so the toggle's two-line label does not centre everything else.
const MobileHeaderRow = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween};
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 6px;
`;

const HeaterBlock = styled.div`
  width: 100%;
  ${flexDirectionColumn};
  align-items: stretch;

  & + & {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 0.5px solid #ffffff29;
  }
`;

// Only shown when the SSR carries more than one heater — with a single heater
// the count is noise, and the panel reads as it always has.
const HeaterBlockTitle = styled.span`
  font-size: 8px;
  color: #95ff45;
  text-align: left;
  margin-bottom: 2px;
`;

// The four figures are fixed-width tiles. Three across leaves the fourth alone
// on a second row against a wide gap, so they pair off two by two instead.
const HeaterFigures = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-around;
  gap: 4px 8px;

  /* SSRInfoCommonContainer indents the current tile to line it up with the
     selector on the row above. In this grid it has no such row to line up with. */
  > div:first-child {
    margin-left: 0;
  }
`;

const MobileSettingButton = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 50%;

  ${layerA};
  ${flexBoxCenter};

  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

const MobileSettingIcon = styled.img`
  height: 60%;
`;

const MobilePasswordWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  ${flexBoxCenter};
  z-index: 100;
  cursor: pointer;
`;

// for desktop
const Wrapper = styled.div`
  ${(p) =>
    p.isMobile
      ? css`
          width: 289px;
          /* The card used to be pinned to the height of a single heater. An SSR
             can carry several, and the admin editor is taller still. */
          min-height: 151px;
          border-radius: 16px;
          margin-bottom: 8px;
          ${flexDirectionColumn};
          align-items: stretch;
          padding: 8px 6px;
          position: relative;

          /* This was painted with BG-ssr-details.svg — a 289x151 drawing whose
             panes sit at fixed coordinates. Once the card grew past one heater,
             stretching that artwork dragged its panes out of line with the rows
             beneath them. Same on/off and fault language as the desktop panel,
             drawn in CSS so it grows with the content. */
          background: transparent
            linear-gradient(
              180deg,
              ${p.isOff ? '#565656' : '#233a54'} 0%,
              ${p.isOff ? '#1d1d1d' : '#060d19'} 100%
            );
          box-shadow: inset 0px 0.5px 1px #ffffff29, 0px 0px 1px #000000;
          border: 0.5px solid #000000;

          ${p.isFault &&
          css`
            border: 1px solid red;
          `}

          ${p.isOverAmp &&
          css`
            border: 1px solid #ff7800;
          `}
        `
      : css`
          width: 100%;

          display: flex;
          flex-direction: column;
          padding: 0 5px;

          margin-bottom: 5px;

          transition: all 200ms ease-in-out;

          /* For the switch name selection box*/
          position: relative;
        `}
`;

const FlexContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;

  /* transition: all 200ms ease-in-out; */
`;

const ToggleSWitchContainer = styled.div`
  ${(p) =>
    p.isMobile &&
    css`
      /* This used to hang off the top-left corner. It shared that corner with
         nothing while the card held one heater and no settings cog; now it sits
         in the header row so it cannot land on top of the figures below. */
      flex-shrink: 0;
    `}
`;

const SwitchNameSelectorWrapper = styled.div`
  position: absolute;
  top: 62px;
  width: 183px;
  height: auto;
  ${alignItemsFlexStart};
  flex-direction: column;
  gap: 6px;
`;
